<div id="uiTable">
    <p-table [columns]="headers" [value]="data" [responsive]="true" #uiTable [paginator]="showPagination" [rows]="recordsToDisplay" [rowsPerPageOptions]="rowsOptions" (sortFunction)="sort($event)" [customSort]="true" [sortField]="sortField" [sortOrder]="sortOrder"
        (onPage)="pageChange($event)" [globalFilterFields]="globalColumnsToSearch" [scrollable]="checkScrollable()" [scrollHeight]="getScrollHeight()" [scrollDirection]="'both'" [virtualScroll]="checkScrollable()" (onFilter)="filter()">
        <ng-template pTemplate="caption" *ngIf="caption || showFilter || showExport">
            <div class="d-flex flex-column">
                <div class="d-flex w-100" *ngIf="caption">
                    {{caption}}
                </div>
                <div class="d-flex flex-row justify-content-between" *ngIf="showFilter || showExport">
                    <div class="d-flex" *ngIf="showFilter">
                        <input type="text" size="50" placeholder="Filter" (input)="uiTable.filterGlobal($any($event.target).value, 'contains')" class="form-control form-control-sm ms-auto me-auto">
                    </div>
                    <div class="d-flex" *ngIf="showExport">
                        <a href="javascript:void(0)" (click)="exportTableToPDF()" uib-tooltip="Export to PDF" class="ps-1">
                            <span class="fas fa-file-pdf fa-2x fa-font-export  text-danger" aria-hidden="true"></span>
                        </a>
                        <a href="javascript:void(0)" (click)="exportTableToXLS()" uib-tooltip="Export to XLS" class="ps-1">
                            <span class="fas fa-file-excel fa-2x fa-font-export text-success" aria-hidden="true"></span>
                        </a>
                        <a href="javascript:void(0)" (click)="printTable()" uib-tooltip="Print Table" class="ps-1">
                            <span class="fas fa-print fa-2x fa-font-export" aria-hidden="true"></span>
                        </a>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="getSortableColumn(col)" [class]="col.cssClass" pFrozenColumn [frozen]="checkIfColumnHasToBeFrozen(col)" [alignFrozen]="'right'">
                    <ng-container [ngSwitch]="col.cellTemplate">
                        <ng-container *ngSwitchCase="'CHECKBOX'">
                            <p-checkbox value="Y" (onChange)="handleHeaderClickEvent($event)" *ngIf="showSelectCheckbox" #headerCheckbox>
                            </p-checkbox>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <div class="d-flex">
                                <div class="d-flex">
                                    {{col.text}}
                                </div>
                                <div class="d-flex">
                                    <ng-container *ngIf="!col.noSort">
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </th>
                <th *ngIf="showEdit" class="table-verysmall-cell-width hidden-print" pFrozenColumn [alignFrozen]="'right'">Edit
                </th>
                <th *ngIf="showDelete" class="table-verysmall-cell-width hidden-print" pFrozenColumn [alignFrozen]="'right'">
                    Delete</th>
                <th *ngIf="showApproveReject" class="table-large-cell-width" pFrozenColumn [alignFrozen]="'right'">
                    </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody" let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    <div class="">Loading</div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr #row>
                <td *ngFor="let col of columns; let i = index" (dblclick)="handleClickEvent(rowData, 'DBLCLICK')" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" [class]="col.cssClass" pFrozenColumn [frozen]="checkIfColumnHasToBeFrozen(col)" [alignFrozen]="'right'">
                    <span class="p-column-title">{{col.text}}</span>
                    <ng-container [ngSwitch]="col.cellTemplate">
                        <ng-container *ngSwitchCase="'LINK'">
                            <ng-container [ngSwitch]="rowData.isEditable">
                                <span *ngSwitchCase="false">{{rowData[col.field]}}</span>
                                <ng-container *ngSwitchDefault>
                                    <ng-container *ngIf="col.showOverlay">
                                        <ng-container [ngSwitch]="col.overLayTemplateId">
                                            <ng-container *ngSwitchCase="'tempLogDetails'">
                                                <a *ngIf="disableTable" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" href="javascript:void(0)" class="disabledAnchor ps-0">{{rowData[col.field]}}</a>
                                                <a *ngIf="!disableTable" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" href="javascript:void(0)" class="ps-0" (click)="showOverlay($event, rowData, tempLogDetails)">{{rowData[col.field]}}</a>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="!col.showOverlay">
                                        <a *ngIf="disableTable" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" href="javascript:void(0)" class="disabledAnchor ps-0">{{rowData[col.field]}}</a>
                                        <a *ngIf="!disableTable" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" href="javascript:void(0)" class="ps-0" (click)="handleClickEvent(rowData, col.text)">{{rowData[col.field]}}</a>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'MULTISELECT'">
                            <ng-container [ngSwitch]="rowData.isEditable">
                                <app-select [isMultiSelect]="true" [selectAllRequired]="true" [options]="multiSelectData.data" [(ngModel)]="rowData[col.field]" class="w-100">
                                </app-select>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'UPDATE'">
                            <ng-container [ngSwitch]="rowData.isEditable">
                                <a href="javascript:void(0)" class="ps-0" (click)="handleClickEvent(rowData, 'UPDATE')"><i
                    class="pi pi-save text-primary pi-size text-center"></i></a>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'POPOVER'" class="text-center">
                            <a href="javascript:void(0)" [popover]="rowData[col.field]" popoverTitle="{{col.title}}" triggers="focus" *ngIf="rowData[col.field]"><i class="fa fa-info-circle fa-fw"></i></a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DATA_POPOVER'" class="text-center">
                            {{rowData[col.field]}}
                            <a href="javascript:void(0)" [popover]="htmlPopover" container="body" [placement]="'auto'" [adaptivePosition]="true" (click)="handleHTMLPopoverEvent(rowData, col.popoverField)" popoverTitle="{{col.popoverTitle}}" triggers="focus" *ngIf="rowData[col.field]"><i class="fa fa-info-circle fa-fw"></i></a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DYNAMIC_POPOVER'" class="text-center">
                            <div class="d-flex w-100" [ngClass]="{'justify-content-between': col.field, 'justify-content-center': !col.field}">
                                <div class="d-flex">
                                    <span *ngIf="col.field">{{rowData[col.field]}}</span>
                                </div>
                                <div class="d-flex" *ngIf="!rowData.hidePopOver">
                                    <a href="javascript:void(0)" (click)="handleDynamicPopoverEvent(rowData)" [popover]="facilityInfoTemplate" container="body" [placement]="'auto'" [outsideClick]="true" [ngClass]="{'text-right': col.field}"><i class="fa fa-info-circle fa-fw"></i></a>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'RADIO'">
                            <p-radioButton [value]="rowData" [(ngModel)]="selectedRow" (onClick)="handleClickEvent(rowData, 'EDIT')" [disabled]="!rowData.canSelect"></p-radioButton>
                        </ng-container>
                        <ng-container *ngSwitchCase="'CHECKBOX'">
                            <p-checkbox value="Y" (onChange)="handleClickEvent(rowData, 'CHECKEDIT')" [(ngModel)]="rowData[col.field]" [disabled]="rowData.isDisabled" *ngIf="rowData.canSelect">
                            </p-checkbox>
                        </ng-container>
                        <ng-container *ngSwitchCase="'RECORD_TEMP'">
                            <ng-container [ngSwitch]="rowData.canRecordTemp">
                                <a *ngIf="disableTable" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" href="javascript:void(0)" class="disabledAnchor ps-0"><i class="fas fa-plus-circle"></i></a>
                                <a *ngIf="!disableTable" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" href="javascript:void(0)" class="ps-0" (click)="handleClickEvent(rowData, col.text)"><i
                    class="fas fa-plus-circle"></i></a>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngSwitchCase="'VIEW'">
                            <a *ngIf="disableTable" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" href="javascript:void(0)" class="disabledAnchor ps-0"><i class="fas fa-list"></i></a>
                            <a *ngIf="!disableTable" [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)" href="javascript:void(0)" class="ps-0" (click)="handleClickEvent(rowData, col.text)"><i
                  class="fas fa-list"></i></a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'VIEWBTN'">
                            <button pRipple class="btn btn-sm btn-primary" (click)="handleClickEvent(rowData, 'VIEWBTN')">View</button>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <span [ngClass]="getCssClass(rowData.serialNum, col.field, col.cellTemplate)">{{rowData[col.field]}}</span>
                        </ng-container>
                    </ng-container>
                    
                </td>
                <td *ngIf="showEdit" class="justify-content-center table-verysmall-cell-width  hidden-print" pFrozenColumn [alignFrozen]="'right'">
                    <a *ngIf="disableTable || !rowData.canEdit" href="javascript:void(0)" class="disabledAnchor ps-0"><i
              class="fas fa-ban text-primary text-center"></i></a>
                    <a *ngIf="!disableTable && rowData.canEdit" href="javascript:void(0)" class="ps-0" (click)="handleClickEvent(rowData, 'EDIT')"><i class="fas fa-pencil-alt text-primary text-center"></i></a>
                </td>
                <td *ngIf="showDelete" class="justify-content-center table-verysmall-cell-width  hidden-print" pFrozenColumn [alignFrozen]="'right'">
                    <a *ngIf="disableTable || !rowData.canDelete" href="javascript:void(0)" class="disabledAnchor ps-0"><i
              class="fas fa-ban text-danger text-center"></i></a>
                    <a *ngIf="!disableTable && rowData.canDelete" href="javascript:void(0)" class="ps-0" (click)="handleDeleteRowEvent(rowData)"><i class="fas fa-trash-alt text-danger text-center"></i></a>
                </td>
                <td *ngIf="showApproveReject" class="justify-content-center table-large-cell-width  hidden-print" pFrozenColumn [alignFrozen]="'right'">
                    <button type="button" class="btn btn-warning btn-sm" (click)="handleRejectRowEvent(rowData)"> Reject</button>
                    <button type="button" class="btn btn-success btn-sm" (click)="handleApproveRowEvent(rowData)"> Approve</button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns="columns">
            <tr>
                <td style="text-align: center;" [attr.colspan]="headers.length">
                    {{emptyMessage}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <div class="text-center" *ngIf="state.rows">
                {{state.first + 1}} - {{state.rows*(state.page + 1) >= state.totalRecords ? state.totalRecords : state.rows*(state.page+1)}} of {{state.totalRecords}}
            </div>
        </ng-template>
    </p-table>
</div>
<ng-template #facilityInfoTemplate>
    <div [innerHTML]="htmlPopoverContent"></div>
</ng-template>
<p-overlayPanel #tempLogDetails [showCloseIcon]="true" [appendTo]="'body'">
    <ng-template pTemplate>
        <app-view-temperature-log-details [rowData]="rowData" (cancelEvent)="tempLogDetails.hide()">
        </app-view-temperature-log-details>
    </ng-template>
</p-overlayPanel>
<ng-template #htmlPopover>
    <div [innerHTML]="htmlPopoverContent"></div>
</ng-template>